module.exports = "/images/chat-bubbles.svg?614579cca635e4d6741282ee6a83e766";